import {makeObservable, observable} from 'mobx';
import {SiderNavigationStore} from './SiderNavigationStore';
import UserStore from './UserStore';
import {ProjectsListStore} from './projects/ProjectsListStore';
import {ProjectsStore} from './projects/ProjectsStore';
import {JobStore} from './jobs/JobStore';
import {JobsListStore} from './jobs/JobsListStore';
import {TaskRunningStore} from './TaskRunningStore';
import {TaskRerunStore} from './TaskRerunStore';
import {TaskEvoRunStore} from './TaskEvoRunStore';
import {TaskCodePackageStore} from './TaskCodePackageStore';
import {BillingStore} from './BillingStore';

// 新的 Store 架构
import {TaskExecutionStore} from './taskRunning/TaskExecutionStore';
import {StageDataCache} from './taskRunning/StageDataCache';
import {OperationLoadingStore} from './taskRunning/OperationLoadingStore';
import {ConfirmDialogStore} from './taskRunning/ConfirmDialogStore';
import {ViewStateStore} from './taskRunning/ViewStateStore';

class RootStore {
    siderNavigationStore = new SiderNavigationStore();
    userStore: UserStore;
    billingStore: BillingStore;

    constructor() {
        this.userStore = new UserStore();
        this.billingStore = new BillingStore();

        makeObservable(this, {
            siderNavigationStore: observable,
            userStore: observable,
            billingStore: observable
        });
    }
}

const rootStore = new RootStore();

export {
    rootStore,
    RootStore,
    SiderNavigationStore,
    UserStore,
    ProjectsStore,
    ProjectsListStore,
    JobStore,
    JobsListStore,
    TaskRunningStore,
    TaskRerunStore,
    TaskEvoRunStore,
    TaskCodePackageStore,
    BillingStore,
    // 新的 Store
    TaskExecutionStore,
    StageDataCache,
    OperationLoadingStore,
    ConfirmDialogStore,
    ViewStateStore
};
